var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActivityPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_9005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.92712 5.20039C3.92712 7.85137 6.03697 10.0004 8.63963 10.0004C11.2423 10.0004 13.3521 7.85137 13.3521 5.20039C13.3521 2.54941 11.2423 0.400391 8.63963 0.400391C6.03697 0.400391 3.92712 2.54941 3.92712 5.20039Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.6006C0 18.8946 1.52491 19.6006 8.6396 19.6006C15.7543 19.6006 17.2792 18.8946 17.2792 15.6006C17.2792 12.3066 15.7543 11.6006 8.6396 11.6006C1.52491 11.6006 0 12.3066 0 15.6006Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6592 6.23434C18.9659 5.92189 19.4632 5.92189 19.7699 6.23434C20.0767 6.54674 20.0767 7.05329 19.7699 7.36569L16.5998 10.5947C16.4381 10.7595 16.2234 10.8373 16.0115 10.8283C15.8179 10.8229 15.6261 10.7448 15.4783 10.5943L14.3676 9.46297C14.0608 9.15057 14.0608 8.64401 14.3676 8.33161C14.6743 8.01916 15.1716 8.01916 15.4783 8.33161L16.0393 8.90297L18.6592 6.23434Z",
    fill: "#16A34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_9005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActivityPerson);
export default __webpack_public_path__ + "static/media/ic_activity_person.53a6e7be756c4fb9a03ab134869b2307.svg";
export { ForwardRef as ReactComponent };